// extracted by mini-css-extract-plugin
export var item = "fg_tl";
export var text = "fg_jG";